module.exports = __webpack_public_path__ + "img/b75dbe5.png";